import { render, staticRenderFns } from "./CreateBloodGroup.vue?vue&type=template&id=2ecbd78a"
import script from "./CreateBloodGroup.vue?vue&type=script&lang=js"
export * from "./CreateBloodGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports